// 读取cookie 值
const cookie = {
  read(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'))
    return match ? decodeURIComponent(match[3]) : null; // 一个括号就是一个数组值，因此cookie的值是第3个。
  }
}

export default cookie;
